import Overflow from "./lib/Overflow";

export default function init(selector) {
    document.querySelectorAll(selector).forEach(viewport => {
        new Overflow(viewport);
    });
}